import _defineProperty from "@babel/runtime/helpers/defineProperty";
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
import { colors, fonts } from "../../tokens";
import { jsx as ___EmotionJSX } from "@emotion/core";
var addonStyles = _objectSpread({
  boxSizing: "border-box",
  display: "inline-block",
  height: 44,
  padding: 10 - 1,
  // to align with input value, this needs to be 10 minus the border size
  background: colors.gray.lightBackground,
  border: "solid 1px var(--CDS-color-semantic-surface-foreground-subtle);",
  color: colors.gray.inkSubdued,
  whiteSpace: "nowrap"
}, fonts["body-1"]);
var prefixStyles = {
  gridArea: "prefix",
  borderTopLeftRadius: "var(--CDS-border-radius-s)",
  borderBottomLeftRadius: "var(--CDS-border-radius-s)",
  borderRight: "none"
};
var suffixStyles = {
  gridArea: "suffix",
  borderLeft: "none",
  borderTopRightRadius: "var(--CDS-border-radius-s)",
  borderBottomRightRadius: "var(--CDS-border-radius-s)"
};
var smallStyles = _objectSpread({
  height: 32,
  // padding top/bottom = (height - lineHeight - border) / 2
  paddingTop: 5,
  paddingBottom: 5
}, fonts["body-2"]);
var largeStyles = _objectSpread({
  height: 48,
  // padding top/bottom = (height - lineHeight - border) / 2
  paddingTop: 11,
  paddingBottom: 11
}, fonts["heading-2"]);
export var Addon = function Addon(_ref) {
  var children = _ref.children,
    size = _ref.size,
    type = _ref.type;
  var styles = [addonStyles];
  if (type === "prefix") styles.push(prefixStyles);
  if (type === "suffix") styles.push(suffixStyles);
  if (size === "small") styles.push(smallStyles);
  if (size === "large") styles.push(largeStyles);
  return ___EmotionJSX("div", {
    css: styles
  }, children);
};